export default "__VITE_ASSET__CT33E4D6__"